// extracted by mini-css-extract-plugin
export var body = "_m5-8";
export var button = "_m5-0";
export var closeButton = "_m5-5";
export var content = "_m5-3";
export var empty = "_m5-f";
export var grid = "_m5-c";
export var header = "_m5-4";
export var icon = "_m5-1";
export var option = "_m5-d";
export var optionSelected = "_m5-e";
export var overlay = "_m5-2";
export var searchIcon = "_m5-a";
export var searchInput = "_m5-b";
export var searchWrapper = "_m5-9";
export var title = "_m5-6";
export var visuallyHidden = "_m5-7";